// extracted by mini-css-extract-plugin
export default {"pricingTable":"style_pricingTable__Ka1CI"};